import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { faPlus, faTimes, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'

import App from './App'

Vue.use(BootstrapVue)
Vue.use(FontAwesomeIcon)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

library.add(faPlus, faTimes, faSpinner, faTrash)

const preloaderElement = document.querySelector('#preloader')
if (preloaderElement) preloaderElement.remove()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js